package com.gsb.vyapar.bhagya.datasource.mqtt

import com.gsb.vyapar.bhagya.util.getMQTTCertificate
import com.gsb.vyapar.bhagya.util.value

val MQTT_CA_CERTIFICATE_PEM: String = getMQTTCertificate().value()

fun mqttCaCertificatePem(): String = MQTT_CA_CERTIFICATE_PEM

fun mqttCaCertificateBytes(): ByteArray = MQTT_CA_CERTIFICATE_PEM.encodeToByteArray()
